export default __webpack_public_path__ + "f1f357e72d01760ffc8e8f2ea60639ba.png";